export enum DomainExtension {
  Ru = 'ru',
  By = 'by',
  Net = 'net',
}
